// We need this import in order to be able to use async/await functions with babel
import 'regenerator-runtime/runtime';

(async () => {
  require('assets/stylesheets/main.scss');
  require('src/initializer/initializeTemplateSettings').default();
  require('src/initializer/trackErrors').default();
  require('src/initializer/configureAssetUrl').default();
  await require('src/libs/translateService').loadTranslationFile();
  require('src/initializer/setMetaTags').default();
  require('src/initializer/initializeRouter').default();
})();
